import {TooltipTheme} from 'packages/tooltip/Tooltip.theme';
import {Dark, White} from './colors';

export const DarkTooltip: TooltipTheme = {
    color: White.default,
    backgroundColor: `${Dark.default}`,
    borderColor: `${Dark.default}`,
    boxShadow: undefined,
};
